export default __webpack_public_path__ + "static/media/36I-120336_-43610_0.968b4fa4.jpg";